import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/filterIconDisabled.svg'
import _imports_1 from '@/assets/filterIcon.svg'
import _imports_2 from '@/assets/pdfs.svg'
import _imports_3 from '@/assets/deleteIcon.svg'
import _imports_4 from '@/assets/sortBy.svg'
import _imports_5 from '@/assets/arrowRight.svg'
import _imports_6 from '@/assets/cancel.svg'
import _imports_7 from '@/assets/folderBrowseIcon.svg'


const _hoisted_1 = { class: "mb-5 mx-5 mt-3 ResponsiveControlePage" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "items-center justify-between flex" }
const _hoisted_4 = {
  key: 0,
  class: "title flex items-center"
}
const _hoisted_5 = {
  key: 1,
  class: "title flex items-center"
}
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_12 = { class: "flex items-center justify-center w-full h-16 skeleton mt-4 tableCornerRadius bg-white" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "w-full minheight" }
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = { class: "mainContainer tabStructure flex flex-row w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey" }
const _hoisted_18 = { class: "w-80 heightFixing pr-5" }
const _hoisted_19 = { class: "h-full" }
const _hoisted_20 = {
  key: 0,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_21 = { class: "mt-1.5 text-xs" }
const _hoisted_22 = { class: "text-xs" }
const _hoisted_23 = {
  key: 1,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_24 = {
  key: 2,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_25 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_26 = { class: "buttonposition flex justify-center items-center sendapprovalheight" }
const _hoisted_27 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_28 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_29 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 3,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_32 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_33 = { class: "buttonposition flex justify-center items-center sendapprovalheight" }
const _hoisted_34 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_35 = {
  key: 0,
  class: "flex mt-4 gap-4 flex-wrap"
}
const _hoisted_36 = { class: "pdf w-full rounded-sm" }
const _hoisted_37 = ["href"]
const _hoisted_38 = {
  key: 0,
  class: "text-xs ml-2"
}
const _hoisted_39 = {
  key: 1,
  class: "text-xs ml-1"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 4,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_42 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_43 = { class: "buttonposition flex justify-center items-center sendapprovalheight" }
const _hoisted_44 = { class: "comment-box w-full" }
const _hoisted_45 = { class: "my-3" }
const _hoisted_46 = {
  key: 0,
  class: "comments"
}
const _hoisted_47 = { class: "initials" }
const _hoisted_48 = { class: "w-1/5" }
const _hoisted_49 = { class: "header" }
const _hoisted_50 = { class: "fontSize10PX" }
const _hoisted_51 = { class: "w-4/5 text-xs" }
const _hoisted_52 = {
  key: 5,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_53 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_54 = { class: "buttonposition flex justify-center items-center sendapprovalheight" }
const _hoisted_55 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_56 = {
  key: 0,
  class: "initials"
}
const _hoisted_57 = {
  key: 1,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_58 = {
  key: 2,
  class: "initials"
}
const _hoisted_59 = {
  key: 3,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_60 = {
  key: 4,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_61 = {
  key: 5,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_62 = {
  key: 6,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_63 = {
  key: 7,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_64 = {
  key: 8,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_65 = {
  key: 6,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_66 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_67 = { class: "buttonposition flex justify-center items-center sendapprovalheight" }
const _hoisted_68 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_69 = { class: "flex" }
const _hoisted_70 = {
  key: 0,
  class: "initials"
}
const _hoisted_71 = {
  key: 1,
  class: "initials"
}
const _hoisted_72 = { class: "logContainer w-93" }
const _hoisted_73 = { class: "flex mt-1" }
const _hoisted_74 = {
  key: 0,
  class: "font-semibold text-xs"
}
const _hoisted_75 = {
  key: 1,
  class: "font-semibold text-xs"
}
const _hoisted_76 = {
  key: 2,
  class: "mx-2 text-xs"
}
const _hoisted_77 = {
  key: 3,
  class: "mx-2 text-xs"
}
const _hoisted_78 = {
  key: 4,
  class: "mx-2 text-xs"
}
const _hoisted_79 = {
  key: 5,
  class: "font-semibold text-xs"
}
const _hoisted_80 = {
  key: 6,
  class: "font-semibold text-xs"
}
const _hoisted_81 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_82 = {
  key: 0,
  class: "flex"
}
const _hoisted_83 = { class: "text-xs w-88" }
const _hoisted_84 = {
  key: 1,
  class: "flex"
}
const _hoisted_85 = {
  key: 0,
  class: "font-normal text-xs ml-2"
}
const _hoisted_86 = {
  key: 1,
  class: "font-normal text-xs ml-2"
}
const _hoisted_87 = {
  key: 2,
  class: "font-normal text-xs ml-2"
}
const _hoisted_88 = {
  key: 3,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_89 = {
  key: 4,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_90 = {
  key: 5,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_91 = {
  key: 6,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_92 = {
  key: 7,
  class: "font-semibold text-xs"
}
const _hoisted_93 = {
  key: 8,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_94 = {
  key: 9,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_95 = {
  key: 10,
  class: "font-semibold text-xs"
}
const _hoisted_96 = {
  key: 2,
  class: "flex"
}
const _hoisted_97 = {
  key: 0,
  class: "font-semibold text-xs"
}
const _hoisted_98 = {
  key: 1,
  class: "font-semibold text-xs"
}
const _hoisted_99 = { class: "mx-2 text-xs text-justify" }
const _hoisted_100 = {
  key: 3,
  class: "flex"
}
const _hoisted_101 = {
  key: 4,
  class: "flex"
}
const _hoisted_102 = {
  key: 5,
  class: "flex"
}
const _hoisted_103 = { class: "mx-2 text-xs" }
const _hoisted_104 = {
  key: 6,
  class: "flex"
}
const _hoisted_105 = { class: "mx-2 text-xs" }
const _hoisted_106 = {
  key: 7,
  class: "flex items-center"
}
const _hoisted_107 = { class: "flex ml-4" }
const _hoisted_108 = { class: "w-20 border taskDetailsRightBar rounded-sm border-lightgrey" }
const _hoisted_109 = { class: "m-3" }
const _hoisted_110 = { class: "pt-1.5 overflow-y-scroll thirtyWidthToggle" }
const _hoisted_111 = { class: "flex flex-col mb-3" }
const _hoisted_112 = { class: "mb-3" }
const _hoisted_113 = {
  key: 0,
  class: "mt-2 mb-3"
}
const _hoisted_114 = { key: 1 }
const _hoisted_115 = { class: "mb-3" }
const _hoisted_116 = { class: "my-1" }
const _hoisted_117 = { class: "mb-3" }
const _hoisted_118 = ["max", "disabled"]
const _hoisted_119 = { class: "mb-3" }
const _hoisted_120 = ["disabled", "min"]
const _hoisted_121 = { class: "mb-3" }
const _hoisted_122 = ["min", "disabled"]
const _hoisted_123 = { class: "mb-3" }
const _hoisted_124 = { class: "mb-3" }
const _hoisted_125 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_126 = { class: "relative w-full max-w-xl" }
const _hoisted_127 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_128 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_129 = { class: "impactcontainer popupbodycontainer flex-1 overflow-y-auto" }
const _hoisted_130 = { class: "formcontainer flex flex-col h-full" }
const _hoisted_131 = { class: "flex-1 overflow-auto hide-scrollbar" }
const _hoisted_132 = { class: "row flex flex-col" }
const _hoisted_133 = { class: "upperspacing" }
const _hoisted_134 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_135 = {
  key: 0,
  class: "error-text"
}
const _hoisted_136 = { class: "upperspacing" }
const _hoisted_137 = {
  key: 0,
  class: "text-xs p-1"
}
const _hoisted_138 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_139 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_140 = { class: "buttonposition flex justify-end items-center pt-4" }
const _hoisted_141 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_142 = { class: "popup-business flex-1 overflow-y-auto overflow-x-hidden" }
const _hoisted_143 = { class: "flex flex-col h-full" }
const _hoisted_144 = { class: "flex-1 overflow-auto hide-scrollbar" }
const _hoisted_145 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_146 = { class: "formcontainer flex flex-col" }
const _hoisted_147 = { class: "upperspacing" }
const _hoisted_148 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_149 = {
  key: 0,
  class: "error-text"
}
const _hoisted_150 = { class: "row flex flex-row upperspacing w-full gap-3" }
const _hoisted_151 = { class: "w-1/2" }
const _hoisted_152 = ["min"]
const _hoisted_153 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_154 = {
  key: 0,
  class: "error-text"
}
const _hoisted_155 = { class: "w-1/2" }
const _hoisted_156 = ["min", "max"]
const _hoisted_157 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_158 = {
  key: 0,
  class: "error-text"
}
const _hoisted_159 = { class: "row flex flex-row w-full gap-3 upperspacing" }
const _hoisted_160 = { class: "w-1/2" }
const _hoisted_161 = { class: "mt-2" }
const _hoisted_162 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_163 = {
  key: 0,
  class: "error-text"
}
const _hoisted_164 = { class: "w-1/2" }
const _hoisted_165 = { class: "mt-2" }
const _hoisted_166 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_167 = {
  key: 0,
  class: "error-text"
}
const _hoisted_168 = { class: "upperspacing" }
const _hoisted_169 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_170 = {
  key: 0,
  class: "error-text"
}
const _hoisted_171 = { class: "upperspacing" }
const _hoisted_172 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_173 = ["disabled"]
const _hoisted_174 = ["disabled"]
const _hoisted_175 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_176 = { class: "popup-business flex-1 overflow-y-auto" }
const _hoisted_177 = { class: "flex flex-col h-full" }
const _hoisted_178 = { class: "flex-1 overflow-auto hide-scrollbar" }
const _hoisted_179 = { class: "statuscontainer px-5 pb-5" }
const _hoisted_180 = { class: "formcontainer flex flex-col" }
const _hoisted_181 = { class: "row flex flex-row upperspacing" }
const _hoisted_182 = { class: "w-1/2" }
const _hoisted_183 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_184 = {
  key: 0,
  class: "error-text"
}
const _hoisted_185 = { class: "row flex flex-row upperspacing" }
const _hoisted_186 = { class: "w-full" }
const _hoisted_187 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_188 = {
  key: 0,
  class: "error-text"
}
const _hoisted_189 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_190 = ["disabled"]
const _hoisted_191 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_dotsloader = _resolveComponent("dotsloader")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_commentsEditor = _resolveComponent("commentsEditor")!
  const _component_safeHtml = _resolveComponent("safeHtml")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.presentTemplateTask.mainTaskName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h1", {
              class: _normalizeClass(_ctx.presentTemplateTask.mainTaskName != undefined && _ctx.presentTemplateTask.mainTaskName.length > 40? 'heading-ellipsis':'')
            }, _toDisplayString(_ctx.presentTemplateTask.mainTaskName), 3)
          ]))
        : _createCommentVNode("", true),
      (_ctx.presentTemplateTask.TaskName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("h1", {
              class: _normalizeClass(_ctx.presentTemplateTask.TaskName != undefined && _ctx.presentTemplateTask.TaskName.length > 40? 'heading-ellipsis':'')
            }, _toDisplayString(_ctx.presentTemplateTask.TaskName), 3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.checkOwner() && _ctx.presentTemplateTask.statusCode == 10415)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "btnprimary mr-1.5",
                disabled: _ctx.clickOnButton,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approveOrRejectTheParentApproval(10403)))
              }, "Approve", 8, _hoisted_8),
              _createElementVNode("button", {
                class: "btnprimary mr-1.5",
                disabled: _ctx.clickOnButton,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.approveOrRejectTheParentApproval(10401)))
              }, "Reject", 8, _hoisted_9)
            ]))
          : _createCommentVNode("", true),
        (_ctx.presentTemplateTask.statusCode == 10401 || _ctx.presentTemplateTask.statusCode == 10402)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_ctx.presentTemplateTask.statusCode == 10401)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass(!_ctx.isAddDisabled(10301) ? 'btnprimary':'btndisabled pointer-events-none'),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toStartMainTask(7)))
                  }, "Start", 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.dotsLoading && _ctx.pageStatus == 200)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_dotsloader)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_Tabs, {
                      value: _ctx.selectedTabIndex,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
                      scrollable: "",
                      class: "heightFixing pr-5"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_TabList, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab, tabIndex) => {
                                return (_openBlock(), _createBlock(_component_Tab, {
                                  key: tabIndex,
                                  value: tab.id,
                                  onClick: ($event: any) => (_ctx.toggleTabs(tab))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tab.displayName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab, tabIndex) => {
                              return (_openBlock(), _createBlock(_component_TabPanel, {
                                key: tabIndex,
                                value: tab.id
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_19, [
                                    (tab.id == 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                          _createElementVNode("div", null, [
                                            _cache[46] || (_cache[46] = _createElementVNode("div", { class: "border-b border-lightgrey flex justify-between" }, [
                                              _createElementVNode("div", { class: "flex items-center marginTopForDoc marginBottomForDoc justify-center" }, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("p", { class: "my-1 header" }, "Title")
                                                ])
                                              ])
                                            ], -1)),
                                            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.presentTemplateTask.mainTaskName), 1)
                                          ]),
                                          _cache[47] || (_cache[47] = _createElementVNode("div", null, [
                                            _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                              _createElementVNode("p", { class: "my-1.5 header" }, "Description")
                                            ]),
                                            _createElementVNode("p", { class: "mt-1.5 headerText" })
                                          ], -1)),
                                          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.presentTemplateTask.description), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (tab.id == 2)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[48] || (_cache[48] = [
                                          _createElementVNode("div", { class: "border-b border-lightgrey flex justify-between" }, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "pb-2.5 mt-2.5 header" }, "Documents")
                                            ]),
                                            _createElementVNode("div", { class: "buttonposition flex justify-center items-center" })
                                          ], -1)
                                        ]))]))
                                      : _createCommentVNode("", true),
                                    (tab.id == 3)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_25, [
                                              _cache[50] || (_cache[50] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("p", { class: "pb-2.5 mt-2.5 header" }, "Related Tasks")
                                                ])
                                              ], -1)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_26, [
                                                  _createElementVNode("div", _hoisted_27, [
                                                    _createElementVNode("button", {
                                                      class: _normalizeClass(["flex", _ctx.tableRow.length == 0 ? 'filterButtonDisable pointer-events-none' : 'filterButton']),
                                                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
                                                    }, [
                                                      (_ctx.tableRow.length == 0)
                                                        ? (_openBlock(), _createElementBlock("img", _hoisted_28))
                                                        : (_openBlock(), _createElementBlock("img", _hoisted_29)),
                                                      _cache[49] || (_cache[49] = _createTextVNode(" Filters ", -1))
                                                    ], 2)
                                                  ])
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_tableData, {
                                              tableRowData: _ctx.tableRow,
                                              headersData: _ctx.Headers
                                            }, null, 8, ["tableRowData", "headersData"]),
                                            (_ctx.toolTipActive)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                  _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (tab.id == 4)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_32, [
                                              _cache[51] || (_cache[51] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("p", { class: "my-1.5 header" }, "Evidence")
                                                ])
                                              ], -1)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_33, [
                                                  _createElementVNode("div", _hoisted_34, [
                                                    _createElementVNode("button", {
                                                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openFilePopup && _ctx.openFilePopup(...args))),
                                                      for: "upload",
                                                      class: _normalizeClass(_ctx.presentTemplateTask.statusCode == 10403||_ctx.presentTemplateTask.statusCode==10401? 'btndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons')
                                                    }, "Attach", 2)
                                                  ])
                                                ])
                                              ])
                                            ]),
                                            (Object.keys(_ctx.presentTemplateTask).includes('evidences'))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentTemplateTask.evidences, (doc, evidenceIndex) => {
                                                    return (_openBlock(), _createElementBlock("div", { key: evidenceIndex }, [
                                                      _createElementVNode("div", _hoisted_36, [
                                                        _createElementVNode("a", {
                                                          href: _ctx.sanitizeUrl(doc.url),
                                                          target: "_blank",
                                                          rel: "noopener noreferrer",
                                                          class: "flex w-full flex-row items-center"
                                                        }, [
                                                          _cache[52] || (_cache[52] = _createElementVNode("img", {
                                                            src: _imports_2,
                                                            alt: ""
                                                          }, null, -1)),
                                                          (Object.keys(doc).includes('filename'))
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(doc.filename), 1))
                                                            : (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(doc.name), 1)),
                                                          _createElementVNode("img", {
                                                            src: _imports_3,
                                                            alt: "",
                                                            onClick: _withModifiers(($event: any) => (_ctx.removeEvidence(evidenceIndex)), ["stop","prevent"]),
                                                            class: _normalizeClass(_ctx.presentTemplateTask.statusCode == 10403||_ctx.presentTemplateTask.statusCode==10401? 'h-5 w-5 pointer-events-none ml-auto' : 'h-5 w-5 cursor-pointer ml-auto')
                                                          }, null, 10, _hoisted_40)
                                                        ], 8, _hoisted_37)
                                                      ])
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (tab.id == 6)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_42, [
                                              _cache[55] || (_cache[55] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("p", { class: "my-2.5 header" }, "Comments")
                                                ])
                                              ], -1)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_43, [
                                                  (_ctx.oldComments)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: "btnprimary flex taskEditButtons",
                                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortComments()))
                                                      }, [...(_cache[53] || (_cache[53] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_4,
                                                          class: "h-3 mr-2"
                                                        }, null, -1),
                                                        _createTextVNode(" Newest ", -1)
                                                      ]))]))
                                                    : _createCommentVNode("", true),
                                                  (!_ctx.oldComments)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        class: "btnprimary flex taskEditButtons",
                                                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortComments()))
                                                      }, [...(_cache[54] || (_cache[54] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_4,
                                                          class: "h-3 mr-2 rotate-180"
                                                        }, null, -1),
                                                        _createTextVNode(" Oldest ", -1)
                                                      ]))]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_44, [
                                                _createElementVNode("div", _hoisted_45, [
                                                  _createVNode(_component_commentsEditor)
                                                ])
                                              ]),
                                              (Object.keys(_ctx.presentTemplateTask).includes('comments'))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentTemplateTask.comments, (obj, index) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        class: "border border-lightgrey mt-2 rounded-sm flex flex-row p-2",
                                                        key: index
                                                      }, [
                                                        _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.extractInitials( (obj.name) )), 1),
                                                        _createElementVNode("div", _hoisted_48, [
                                                          _createElementVNode("div", _hoisted_49, _toDisplayString((obj.name)), 1),
                                                          _createElementVNode("div", _hoisted_50, _toDisplayString(obj.createdAt), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_51, [
                                                          _createVNode(_component_safeHtml, {
                                                            content: obj.comment
                                                          }, null, 8, ["content"])
                                                        ])
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (tab.id == 5)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                          _createElementVNode("div", _hoisted_53, [
                                            _cache[56] || (_cache[56] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", { class: "header" }, "Approvals")
                                              ])
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_54, [
                                                _createElementVNode("div", _hoisted_55, [
                                                  _createElementVNode("button", {
                                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openApprovalpopup())),
                                                    class: _normalizeClass(_ctx.presentTemplateTask.statusCode==10403 ?'btnprimary pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons mb-1.5')
                                                  }, "Send Approval", 2)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentTemplateTask.approvals, (approval, number) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: number,
                                                class: "bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full"
                                              }, [
                                                (approval.createdBy != undefined && !approval.updatedBy)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.extractInitials((approval.name))), 1))
                                                  : _createCommentVNode("", true),
                                                (approval.createdBy != undefined && !approval.updatedBy)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString((approval.name)), 1))
                                                  : _createCommentVNode("", true),
                                                (approval.updatedBy != undefined)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.extractInitials((approval.name))), 1))
                                                  : _createCommentVNode("", true),
                                                (approval.updatedBy != undefined)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString((approval.name)), 1))
                                                  : _createCommentVNode("", true),
                                                (approval.statusCode == 10401)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(' Requested an approval ')))
                                                  : (approval.statusCode == 10410)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(' Rejected an approval ')))
                                                    : (approval.statusCode == 10403)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(' Approved an approval ')))
                                                      : _createCommentVNode("", true),
                                                (approval.createdAt != undefined)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(_ctx.formatDate(approval.createdAt)), 1))
                                                  : _createCommentVNode("", true),
                                                (approval.updatedAt != undefined)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(_ctx.formatDate(approval.updatedAt)), 1))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (tab.id == 7)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_66, [
                                              _cache[59] || (_cache[59] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("p", { class: "header" }, "History")
                                                ])
                                              ], -1)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_67, [
                                                  _createElementVNode("div", _hoisted_68, [
                                                    (_ctx.newHistory)
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 0,
                                                          class: "btnprimary flex taskEditButtons",
                                                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortWorkLog()))
                                                        }, [...(_cache[57] || (_cache[57] = [
                                                          _createElementVNode("img", {
                                                            src: _imports_4,
                                                            class: "h-3 mr-2"
                                                          }, null, -1),
                                                          _createTextVNode(" Oldest ", -1)
                                                        ]))]))
                                                      : _createCommentVNode("", true),
                                                    (!_ctx.newHistory)
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 1,
                                                          class: "btnprimary flex taskEditButtons",
                                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortWorkLog()))
                                                        }, [...(_cache[58] || (_cache[58] = [
                                                          _createElementVNode("img", {
                                                            src: _imports_4,
                                                            class: "h-3 mr-2 rotate-180"
                                                          }, null, -1),
                                                          _createTextVNode(" Newest ", -1)
                                                        ]))]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ])
                                              ])
                                            ]),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject.taskHistory, (work) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: work,
                                                class: "bg-white p-4 mb-0.5 border-lightgrey border-b w-full"
                                              }, [
                                                _createElementVNode("div", _hoisted_69, [
                                                  (Object.keys(work).includes('createdBy'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(_ctx.extractInitials((work.name))), 1))
                                                    : _createCommentVNode("", true),
                                                  (Object.keys(work).includes('updatedBy'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(_ctx.extractInitials((work.name))), 1))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("div", _hoisted_72, [
                                                    _createElementVNode("div", _hoisted_73, [
                                                      (Object.keys(work).includes('createdBy'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString((work.name)), 1))
                                                        : (Object.keys(work).includes('updatedBy'))
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_75, _toDisplayString((work.name)), 1))
                                                          : _createCommentVNode("", true),
                                                      (work.actionEntity == 10301)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_76, _toDisplayString('Created the Task on')))
                                                        : (work.statusCode != undefined && work.statusCode == 10418)
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_77, _toDisplayString('Terminated the Task on')))
                                                          : (work.actionEntity == 10302)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_78, _toDisplayString('Updated the Task on')))
                                                            : _createCommentVNode("", true),
                                                      (Object.keys(work).includes('createdAt'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_79, _toDisplayString(_ctx.formatTime(work.createdAt)), 1))
                                                        : _createCommentVNode("", true),
                                                      (Object.keys(work).includes('updatedAt'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_80, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    (Object.keys(work).includes('additionalInfo'))
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                                          (Object.keys(work.additionalInfo).includes('comment'))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                                                _cache[60] || (_cache[60] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Comment :'), -1)),
                                                                _createElementVNode("p", _hoisted_83, [
                                                                  _createVNode(_component_safeHtml, {
                                                                    content: work.additionalInfo.comment
                                                                  }, null, 8, ["content"])
                                                                ])
                                                              ]))
                                                            : _createCommentVNode("", true),
                                                          (Object.keys(work.additionalInfo).includes('dateId'))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                                                _cache[61] || (_cache[61] = _createElementVNode("p", { class: "font-normal text-xs" }, _toDisplayString('Updated the '), -1)),
                                                                (work.additionalInfo.dateId==20606)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_85, _toDisplayString(' Completion Date from')))
                                                                  : (work.additionalInfo.dateId==20604)
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString(' Start Date from')))
                                                                    : (work.additionalInfo.dateId==20605)
                                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_87, _toDisplayString(' dueDate from')))
                                                                      : _createCommentVNode("", true),
                                                                (work.additionalInfo.previousCompletionDate!='' && work.additionalInfo.dateId==20606)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_88, _toDisplayString(_ctx.formatDate(work.additionalInfo?.previousCompletionDate)), 1))
                                                                  : (work.additionalInfo.previousStartDate!='' && work.additionalInfo.dateId==20604)
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_89, _toDisplayString(_ctx.formatDate(work.additionalInfo?.previousStartDate)), 1))
                                                                    : (work.additionalInfo.previousEndDate!='' && work.additionalInfo.dateId==20605)
                                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString(_ctx.formatDate(work.additionalInfo?.previousEndDate)), 1))
                                                                      : (_openBlock(), _createElementBlock("p", _hoisted_91, "N/A")),
                                                                _cache[62] || (_cache[62] = _createElementVNode("p", { class: "mx-2 font-normal text-xs" }, _toDisplayString('to'), -1)),
                                                                (work.additionalInfo.updatedCompletionDate!=''&& work.additionalInfo.dateId==20606)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_92, _toDisplayString(_ctx.formatDate(work.additionalInfo.updatedCompletionDate)), 1))
                                                                  : (work.additionalInfo.updatedStartDate!=''&& work.additionalInfo.dateId==20604)
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_93, _toDisplayString(_ctx.formatDate(work.additionalInfo?.updatedStartDate)), 1))
                                                                    : (work.additionalInfo.updatedEndDate!='' && work.additionalInfo.dateId==20605)
                                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_94, _toDisplayString(_ctx.formatDate(work.additionalInfo?.updatedEndDate)), 1))
                                                                      : (_openBlock(), _createElementBlock("p", _hoisted_95, "N/A"))
                                                              ]))
                                                            : _createCommentVNode("", true),
                                                          (Object.keys(work.additionalInfo).includes('approver'))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                                                (Object.keys(work.additionalInfo).includes('action') && work.additionalInfo.action==10301)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString('Requested approval from -')))
                                                                  : (!Object.keys(work).includes('action'))
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_98, _toDisplayString('Request approved By -')))
                                                                    : _createCommentVNode("", true),
                                                                _createElementVNode("p", _hoisted_99, _toDisplayString((work.additionalInfo.name)), 1)
                                                              ]))
                                                            : _createCommentVNode("", true),
                                                          (work.additionalInfo.approvalStatusCode == 10410)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [...(_cache[63] || (_cache[63] = [
                                                                _createElementVNode("p", { class: "font-semibold text-xs text-justify" }, _toDisplayString('Approval is Rejected'), -1)
                                                              ]))]))
                                                            : _createCommentVNode("", true),
                                                          (work.additionalInfo.approvalStatusCode == 10403)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_101, [...(_cache[64] || (_cache[64] = [
                                                                _createElementVNode("p", { class: "font-semibold text-xs text-justify" }, _toDisplayString('Approval is Accepted'), -1)
                                                              ]))]))
                                                            : _createCommentVNode("", true),
                                                          (Object.keys(work.additionalInfo).includes('filename'))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                                                _cache[65] || (_cache[65] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Uploaded the Evidence -'), -1)),
                                                                _createElementVNode("p", _hoisted_103, _toDisplayString(work.additionalInfo.filename), 1)
                                                              ]))
                                                            : _createCommentVNode("", true),
                                                          (Object.keys(work.additionalInfo).includes('assignee'))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                                                _cache[66] || (_cache[66] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Assigned the Task To -'), -1)),
                                                                _createElementVNode("p", _hoisted_105, _toDisplayString((work.additionalInfo.name)), 1)
                                                              ]))
                                                            : _createCommentVNode("", true),
                                                          (Object.keys(work.additionalInfo).includes('previousStatus'))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                                                _cache[68] || (_cache[68] = _createElementVNode("div", null, [
                                                                  _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Updated The Status :'))
                                                                ], -1)),
                                                                _createElementVNode("div", _hoisted_107, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorTemplateBg(work.additionalInfo.previousStatus)])
                                                                  }, [
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(_ctx.colorTemplateText(work.additionalInfo.previousStatus))
                                                                    }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.previousStatus)), 3)
                                                                  ], 2),
                                                                  _cache[67] || (_cache[67] = _createElementVNode("div", { class: "mx-4 flex items-center" }, [
                                                                    _createElementVNode("img", { src: _imports_5 })
                                                                  ], -1)),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorTemplateBg(work.additionalInfo.updatedStatus)])
                                                                  }, [
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(_ctx.colorTemplateText(work.additionalInfo.updatedStatus))
                                                                    }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.updatedStatus)), 3)
                                                                  ], 2)
                                                                ])
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    _createElementVNode("div", _hoisted_109, [
                      _cache[82] || (_cache[82] = _createElementVNode("div", { class: "pb-2 border-b border-lightgrey" }, [
                        _createElementVNode("h1", null, "Task Details")
                      ], -1)),
                      _createElementVNode("div", _hoisted_110, [
                        _createElementVNode("div", _hoisted_111, [
                          _cache[69] || (_cache[69] = _createElementVNode("label", { class: "controllabel" }, "Task Status", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass([_ctx.changeBackground(), "taskstatusboxstyling cursor-pointer"])
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(_ctx.changeBackground()),
                              onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                            }, _toDisplayString(_ctx.getStatusLabel1(_ctx.presentTemplateTask.statusCode)), 35)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_112, [
                          _createElementVNode("div", null, [
                            _cache[71] || (_cache[71] = _createElementVNode("label", { class: "controllabel" }, "Assigned To", -1)),
                            _createElementVNode("div", null, [
                              (_ctx.presentTemplateTask.statusCode == 10403 || _ctx.presentTemplateTask.statusCode == 10402 || (_ctx.presentTemplateTask.createdBy != _ctx.userInfo._id && _ctx.presentTemplateTask.assignee != undefined && _ctx.presentTemplateTask.assignee.value != _ctx.userInfo._id))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_113, _toDisplayString(_ctx.presentTemplateTask.assignee != undefined ? _ctx.presentTemplateTask.assignee.label : 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.presentTemplateTask.assignee,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.presentTemplateTask.assignee) = $event)),
                                      suggestions: _ctx.userOptions,
                                      onComplete: _ctx.asyncFind,
                                      onItemSelect: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateAssignedMember(_ctx.presentTemplateTask.assignee))),
                                      disabled: _ctx.presentTemplateTask.statusCode == 10403 || _ctx.isAddDisabled(10301),
                                      appendTo: "self",
                                      optionLabel: "label",
                                      optionValue: "value",
                                      placeholder: "Assigned-To",
                                      class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", {
																	'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
																	'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== ''
																}])
                                    }, {
                                      empty: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                                        _createElementVNode("span", null, "No Members Found", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["modelValue", "suggestions", "onComplete", "disabled", "class"])
                                  ]))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_115, [
                          _cache[72] || (_cache[72] = _createElementVNode("label", { class: "controllabel" }, "Created By", -1)),
                          _cache[73] || (_cache[73] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.getPersonName(_ctx.presentTemplateTask.createdBy)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_117, [
                          _createElementVNode("div", null, [
                            _cache[74] || (_cache[74] = _createElementVNode("label", { class: "controllabel" }, "Start Date", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.presentTemplateTask.startDate) = $event)),
                              class: "mt-2 w-full stylingForInputboxstylingForSelectAtPopup",
                              onFocus: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                              max: _ctx.presentTemplateTask.dueDate,
                              onkeydown: "return false",
                              placeholder: "Select Date",
                              disabled: _ctx.TaskDetailsDropDown.taskStatus ==10403,
                              onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.updateDate(_ctx.presentTemplateTask.startDate,20604)))
                            }, null, 40, _hoisted_118), [
                              [_vModelText, _ctx.presentTemplateTask.startDate]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_119, [
                          _createElementVNode("div", null, [
                            _cache[75] || (_cache[75] = _createElementVNode("label", { class: "controllabel" }, "Due Date", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.presentTemplateTask.dueDate) = $event)),
                              class: "mt-2 w-full stylingForInputboxstylingForSelectAtPopup",
                              onFocus: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                              onkeydown: "return false",
                              placeholder: "Select Date",
                              disabled: _ctx.TaskDetailsDropDown.taskStatus ==10403,
                              min: _ctx.presentTemplateTask.startDate,
                              onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.updateDate(_ctx.presentTemplateTask.dueDate,20605)))
                            }, null, 40, _hoisted_120), [
                              [_vModelText, _ctx.presentTemplateTask.dueDate]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_121, [
                          _cache[76] || (_cache[76] = _createElementVNode("label", { class: "controllabel mb-2" }, "Completion Date", -1)),
                          _cache[77] || (_cache[77] = _createElementVNode("br", null, null, -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.presentTemplateTask.completedAt) = $event)),
                            class: _normalizeClass(["mt-2", {'inputboxstylingForSelectAtPopup': _ctx.presentTemplateTask.startDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.presentTemplateTask.startDate !== ''}]),
                            onFocus: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            min: _ctx.presentTemplateTask.startDate,
                            placeholder: "Select Date",
                            disabled: _ctx.TaskDetailsDropDown.taskStatus ==10403,
                            onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.updateCompletionDate(_ctx.presentTemplateTask.completedAt)))
                          }, null, 42, _hoisted_122), [
                            [_vModelText, _ctx.presentTemplateTask.completedAt]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_123, [
                          _cache[78] || (_cache[78] = _createElementVNode("label", { class: "controllabel mb-2" }, "Team", -1)),
                          _cache[79] || (_cache[79] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", null, _toDisplayString(_ctx.getUserteamName(_ctx.presentTemplateTask.assignee)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_124, [
                          _cache[80] || (_cache[80] = _createElementVNode("label", { class: "controllabel mb-2" }, "Target", -1)),
                          _cache[81] || (_cache[81] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", null, _toDisplayString(_ctx.getTargetInfo(_ctx.presentTemplateTask)), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])),
    (_ctx.importpopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.importpopUp
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_125, [
              _createElementVNode("div", _hoisted_126, [
                _createElementVNode("div", _hoisted_127, [
                  _createElementVNode("div", _hoisted_128, [
                    _cache[84] || (_cache[84] = _createElementVNode("h1", null, "Import files", -1)),
                    _createElementVNode("button", {
                      class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onCancelIcon()))
                    }, [...(_cache[83] || (_cache[83] = [
                      _createElementVNode("img", {
                        src: _imports_6,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))])
                  ]),
                  _cache[89] || (_cache[89] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", _hoisted_129, [
                    _createElementVNode("div", _hoisted_130, [
                      _createElementVNode("div", _hoisted_131, [
                        _createElementVNode("div", _hoisted_132, [
                          _createElementVNode("div", _hoisted_133, [
                            _cache[85] || (_cache[85] = _createElementVNode("label", { class: "controllabel" }, "File Name ", -1)),
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.inputFileName.$error }]),
                              type: "text",
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.inputFileName) = $event)),
                              placeholder: "Filename"
                            }, null, 2), [
                              [
                                _vModelText,
                                _ctx.inputFileName,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.inputFileName.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                  (_ctx.v$.inputFileName.required.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_135, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_136, [
                            _cache[87] || (_cache[87] = _createElementVNode("label", { class: "controllabel" }, "Attachment", -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-auto evidenceHeight bg-white rounded-sm border-solid border border-lightgrey relative overflow-hidden mt-2", {'is-invalid':_ctx.v$.fileToUpload.$error}])
                            }, [
                              _createElementVNode("input", {
                                type: "file",
                                ref: "fileInput",
                                class: "hidden",
                                id: "upload",
                                placeholder: "Choose a file to upload",
                                onChange: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                              }, null, 544),
                              _cache[86] || (_cache[86] = _createElementVNode("label", {
                                for: "upload",
                                class: "float-right cursor-pointer text-white flex justify-center items-center w-9 h-7 bg-primary"
                              }, [
                                _createElementVNode("img", { src: _imports_7 })
                              ], -1)),
                              (_ctx.fileName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_137, _toDisplayString(_ctx.fileName), 1))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          (_ctx.v$.fileToUpload.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                (_ctx.v$.fileToUpload.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_139, "File upload is required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _cache[88] || (_cache[88] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey" }, null, -1)),
                      _createElementVNode("div", _hoisted_140, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary", (_ctx.inputFileName.length == 0) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                          onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
                        }, "Save", 2)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showSubTaskPopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 3,
          popUp: _ctx.showSubTaskPopUp
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_141, [
              _cache[91] || (_cache[91] = _createElementVNode("h1", null, "Sub Tasks", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onCancelButtonAddPopUp()))
              }, [...(_cache[90] || (_cache[90] = [
                _createElementVNode("img", {
                  src: _imports_6,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_142, [
              _createElementVNode("div", _hoisted_143, [
                _createElementVNode("div", _hoisted_144, [
                  _createElementVNode("div", _hoisted_145, [
                    _createElementVNode("div", _hoisted_146, [
                      _createElementVNode("div", _hoisted_147, [
                        _cache[92] || (_cache[92] = _createElementVNode("label", {
                          for: "number",
                          class: "controllabel"
                        }, "Title", -1)),
                        _cache[93] || (_cache[93] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "number",
                          class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.subTaskDetailsObj.subTasktitle.$error }]),
                          disabled: "",
                          placeholder: "Task Name",
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.subTaskDetailsObj.subTasktitle) = $event))
                        }, null, 2), [
                          [
                            _vModelText,
                            _ctx.subTaskDetailsObj.subTasktitle,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.subTaskDetailsObj.subTasktitle.$error )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                              (_ctx.v$.subTaskDetailsObj.subTasktitle.required.$invalid )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_149, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_150, [
                        _createElementVNode("div", _hoisted_151, [
                          _cache[94] || (_cache[94] = _createElementVNode("label", { class: "controllabel text-xs" }, "Start Date", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.subTaskDetailsObj.startDate.$error,'inputboxstylingForSelectAtPopup': _ctx.subTaskDetailsObj.startDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.subTaskDetailsObj.startDate !== ''}]),
                            onFocus: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            min: _ctx.today,
                            onkeydown: "return false",
                            onChange: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.checkForStartDate && _ctx.checkForStartDate(...args))),
                            placeholder: "Select Start Date",
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.subTaskDetailsObj.startDate) = $event))
                          }, null, 42, _hoisted_152), [
                            [_vModelText, _ctx.subTaskDetailsObj.startDate]
                          ]),
                          (_ctx.v$.subTaskDetailsObj.startDate.$error )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                                (_ctx.v$.subTaskDetailsObj.startDate.required.$invalid )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_154, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_155, [
                          _cache[95] || (_cache[95] = _createElementVNode("label", { class: "controllabel text-xs" }, "Due Date", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.subTaskDetailsObj.dueDate.$error,'inputboxstylingForSelectAtPopup': _ctx.subTaskDetailsObj.dueDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.subTaskDetailsObj.dueDate !== '' }]),
                            onFocus: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            onkeydown: "return false",
                            min: _ctx.subTaskDetailsObj.startDate||_ctx.today,
                            max: _ctx.presentTemplateTask.dueDate,
                            onChange: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.checkForStartDate && _ctx.checkForStartDate(...args))),
                            placeholder: "Select Start Date",
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.subTaskDetailsObj.dueDate) = $event))
                          }, null, 42, _hoisted_156), [
                            [_vModelText, _ctx.subTaskDetailsObj.dueDate]
                          ]),
                          (_ctx.v$.subTaskDetailsObj.dueDate.$error )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                (_ctx.v$.subTaskDetailsObj.dueDate.required.$invalid )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_158, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_159, [
                        _createElementVNode("div", _hoisted_160, [
                          _cache[97] || (_cache[97] = _createElementVNode("label", { class: "controllabel text-xs" }, "Responsibility", -1)),
                          _createElementVNode("div", _hoisted_161, [
                            _createVNode(_component_AutoComplete, {
                              modelValue: _ctx.subTaskDetailsObj.team,
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.subTaskDetailsObj.team) = $event)),
                              suggestions: _ctx.teamOptions,
                              disabled: "",
                              onComplete: _ctx.asyncFind2,
                              optionLabel: "label",
                              optionValue: "value",
                              appendTo: "self",
                              placeholder: "Responsibility",
                              class: _normalizeClass(["p-inputtext-sm systemsstyling custom-multiselect userSelect", {
													'p-invalid': _ctx.v$.subTaskDetailsObj.team.$error,
													'has-options': _ctx.teamOptions && _ctx.teamOptions.length > 0,
													'no-options': !_ctx.teamOptions.length &&  _ctx.searchValue !== ''
												}])
                            }, {
                              empty: _withCtx(() => [...(_cache[96] || (_cache[96] = [
                                _createElementVNode("span", null, "No team Found", -1)
                              ]))]),
                              _: 1
                            }, 8, ["modelValue", "suggestions", "onComplete", "class"])
                          ]),
                          (_ctx.v$.subTaskDetailsObj.team.$error )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                (_ctx.v$.subTaskDetailsObj.team.required.$invalid )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_163, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_164, [
                          _cache[99] || (_cache[99] = _createElementVNode("label", { class: "controllabel text-xs" }, "Assigned To", -1)),
                          _createElementVNode("div", _hoisted_165, [
                            _createVNode(_component_AutoComplete, {
                              modelValue: _ctx.subTaskDetailsObj.assignee,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.subTaskDetailsObj.assignee) = $event)),
                              suggestions: _ctx.userOptions,
                              onComplete: _ctx.asyncFind,
                              optionLabel: "label",
                              optionValue: "value",
                              appendTo: "self",
                              placeholder: "Assigned To",
                              class: _normalizeClass(["p-inputtext-sm systemsstyling custom-multiselect userSelect", {
													'p-invalid': _ctx.v$.subTaskDetailsObj.assignee.$error,
													'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
													'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== ''
												}])
                            }, {
                              empty: _withCtx(() => [...(_cache[98] || (_cache[98] = [
                                _createElementVNode("span", null, "No Members Found", -1)
                              ]))]),
                              _: 1
                            }, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                            (_ctx.v$.subTaskDetailsObj.assignee.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                                  (_ctx.v$.subTaskDetailsObj.assignee.required.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_167, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_168, [
                        _cache[100] || (_cache[100] = _createElementVNode("label", { class: "controllabel text-xs" }, "Description", -1)),
                        _cache[101] || (_cache[101] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          name: "Description",
                          placeholder: "Description",
                          id: "",
                          class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.subTaskDetailsObj.description.$error }]),
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.subTaskDetailsObj.description) = $event))
                        }, null, 2), [
                          [
                            _vModelText,
                            _ctx.subTaskDetailsObj.description,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.subTaskDetailsObj.description.$error )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                              (_ctx.v$.subTaskDetailsObj.description.required.$invalid )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_170, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_171, [
                        _cache[102] || (_cache[102] = _createElementVNode("label", { class: "controllabel text-xs" }, "Notes", -1)),
                        _cache[103] || (_cache[103] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          name: "Description",
                          placeholder: "Notes",
                          id: "",
                          class: "inputboxstyling mt-2",
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.subTaskDetailsObj.notes) = $event))
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.subTaskDetailsObj.notes,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[104] || (_cache[104] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-4" }, null, -1)),
                  _createElementVNode("div", _hoisted_172, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["mr-2", (JSON.stringify(_ctx.subTaskDetailsObjDummy) == JSON.stringify(_ctx.subTaskDetailsObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                      disabled: _ctx.clickOnButton,
                      onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.onCancelbtn()))
                    }, "Reset", 10, _hoisted_173),
                    _createElementVNode("button", {
                      class: _normalizeClass(["", (JSON.stringify(_ctx.subTaskDetailsObjDummy) == JSON.stringify(_ctx.subTaskDetailsObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                      disabled: _ctx.clickOnButton,
                      onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.onClickSubmitBtn(_ctx.subTaskDetailsObj)))
                    }, "Save", 10, _hoisted_174)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showApprovalPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 4,
          popUp: _ctx.showApprovalPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_175, [
              _cache[106] || (_cache[106] = _createElementVNode("h1", null, "Approval", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.onCrossbtn()))
              }, [...(_cache[105] || (_cache[105] = [
                _createElementVNode("img", {
                  src: _imports_6,
                  class: "cursor-pointer"
                }, null, -1)
              ]))])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_176, [
              _createElementVNode("div", _hoisted_177, [
                _createElementVNode("div", _hoisted_178, [
                  _createElementVNode("div", _hoisted_179, [
                    _createElementVNode("div", _hoisted_180, [
                      _createElementVNode("div", _hoisted_181, [
                        _createElementVNode("div", _hoisted_182, [
                          _cache[107] || (_cache[107] = _createElementVNode("label", { class: "controllabel mb-2" }, "Name of the Authority", -1)),
                          _createElementVNode("div", null, [
                            _createVNode(_component_AutoComplete, {
                              modelValue: _ctx.taskObj.approver,
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.taskObj.approver) = $event)),
                              suggestions: _ctx.authorityOptions,
                              onComplete: _ctx.asyncFind1,
                              optionLabel: "label",
                              optionValue: "value",
                              placeholder: "Assigned-To",
                              appendTo: "self",
                              class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", {
												'p-invalid': _ctx.v$.taskObj.approver.$error,
												'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
												'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== ''
											}])
                            }, null, 8, ["modelValue", "suggestions", "onComplete", "class"])
                          ]),
                          (_ctx.v$.taskObj.approver.$error )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                                (_ctx.v$.taskObj.approver.$invalid )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_184, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_185, [
                        _createElementVNode("div", _hoisted_186, [
                          _cache[108] || (_cache[108] = _createElementVNode("label", { class: "controllabel" }, "Justification or Comments for Approving", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.taskObj.approvalComments.$error }]),
                            placeholder: "Comments",
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.taskObj.approvalComments) = $event))
                          }, null, 2), [
                            [
                              _vModelText,
                              _ctx.taskObj.approvalComments,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.taskObj.approvalComments.$error )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                                (_ctx.v$.taskObj.approvalComments.$invalid )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_188, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]),
                _cache[109] || (_cache[109] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_189, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["mr-2", (JSON.stringify(_ctx.taskObj) == JSON.stringify(_ctx.taskObjDummy)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                    disabled: _ctx.clickOnButton,
                    onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.onCancelbtnAtApproval()))
                  }, "Reset", 10, _hoisted_190),
                  _createElementVNode("button", {
                    class: _normalizeClass(["", (JSON.stringify(_ctx.taskObj) == JSON.stringify(_ctx.taskObjDummy)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                    disabled: _ctx.clickOnButton,
                    onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.clickOnSaveForApproval(_ctx.taskObj)))
                  }, "Submit", 10, _hoisted_191)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}